import { ExternalLink } from "lucide-react";
import { Link } from "react-router";

interface OpenFullProfileLinkProps {
  candidateId: string;
  variant?: "inline" | "header";
}

const INLINE_CLASSES =
  "inline-flex items-center gap-1 text-xs text-text-muted hover:text-accent hover:underline";

const HEADER_CLASSES =
  "inline-flex items-center gap-1.5 rounded border border-input-border px-3 py-1.5 text-xs font-medium text-text-secondary hover:bg-card-hover";

export function OpenFullProfileLink({ candidateId, variant = "inline" }: OpenFullProfileLinkProps) {
  return (
    <Link
      to={`/candidates/${candidateId}`}
      className={variant === "header" ? HEADER_CLASSES : INLINE_CLASSES}
      data-testid="open-full-profile-link"
    >
      Open full profile <ExternalLink size={variant === "header" ? 14 : 12} />
    </Link>
  );
}
